import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useCookies } from 'react-cookie';

const OuterLayout = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies(['token']);

  useEffect(() => {
    const token = cookies.token;
    const userData = JSON.parse(localStorage.getItem('UserData'));

    if (!!token && !!userData) {
      const homeEmails = [
        'workspace+manage@adbert.com.tw',
        'workspace+marketing@adbert.com.tw',
        'workspace+ceo@adbert.com.tw',
        'workspace+ai@adbert.com.tw',
        'workspace+finance@adbert.com.tw',
        'workspace.admin@adbert.com.tw',
        'workspace.keystone@adbert.com.tw',
      ];
      if (homeEmails.includes(userData?.email)) {
        navigate('/dashboard/tdp/home');
      } else if (userData?.roles?.find((item) => item === 'workspace.tdp')) {
        navigate('/dashboard/tdp/menu');
      } else {
        navigate('/admin/workspace');
      }
    }
  }, [cookies, navigate]);

  return (
    // <GoogleReCaptchaProvider reCaptchaKey={'6LdrKKgeAAAAAKl-TCWdCv2ZhbAd1b91Nu0gAWRx'}>
    <Outlet />
    // </GoogleReCaptchaProvider>
  );
};

export default OuterLayout;
